import { message } from 'antd'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import React from 'react'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { changePassword } from '../../api'
import { logos } from '../../assets'
import { CustomCardRestorePassw } from '../../components'
import { Restorepassword } from '../../validations/ValidationLogin'

export const FormRestorePassword = () => {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    const [screen, setScreen] = useState(1)
    // console.log(searchParams.get("token"))

    const onSubmit = async ({ password, passwordRepeat }, { setSubmitting, resetForm }) => {
        try {
            // console.log(password)
            // console.log(passwordRepeat)
            const response = await changePassword(password, searchParams.get("token"))
            console.log(response)
            if (response.status === 0) {
                resetForm({});
                setScreen(2)
            }
            else {
                setScreen(3)
                message.error("error")
            }
            // navigate();
        } catch (error) {
            setSubmitting(false);
        }
    };

    switch (screen) {
        case 1:
            return <CustomCardRestorePassw>
                <div className='w-full h-3/12  flex justify-center items-center'>
                    <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
                </div>
                <div className='w-full h-9/12 px-12'>
                    <p className='font-bold text-2xl text-white text-center'>Crea una nueva contraseña</p>
                    <Formik
                        initialValues={{
                            password: "",
                            passwordRepeat: "",
                        }}
                        onSubmit={onSubmit}
                        validationSchema={Restorepassword}
                    >
                        {({ handleSubmit, handleChange, values }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="mb-10  h-10 ">
                                    <Field
                                        className="w-full p-4 text-white bg-transparent border-b text-base focus:outline-none border-white rounded placeholder:text-white"
                                        type="password"
                                        placeholder="Nueva contraseña"
                                        name="password"
                                        onChange={handleChange}
                                        value={values.password}
                                        autoComplete="none"
                                    />
                                    <ErrorMessage component="a" className="text-red-600 " name="password" />
                                </div>
                                <div className="mb-4  h-10">
                                    <Field
                                        className="w-full p-4 text-white bg-transparent border-b text-base focus:outline-none border-white rounded placeholder:text-white"
                                        type="password"
                                        placeholder="Confirma contraseña"
                                        name="passwordRepeat"
                                        onChange={handleChange}
                                        value={values.passwordRepeat}
                                        autoComplete="none"
                                    />
                                    <ErrorMessage component="a" className="text-red-600 " name="passwordRepeat" />
                                </div>
                                <div className="mt-12 flex h-full justify-center">
                                    <button type="submit" className="w-[236px] h-12 bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white font-normal text-base rounded-md">
                                        Reestablecer contraseña
                                    </button>
                                </div>
                                <p
                                    onClick={() => { navigate("/auth") }}
                                    className="mt-4 cursor-pointer text-center text-white text-base font-normal ">Regresar a inicio de sesión</p>
                            </Form>
                        )}
                    </Formik>
                </div>
            </CustomCardRestorePassw>
        case 2:
            return <SuccesRestorePassword> </SuccesRestorePassword>
        case 3:
            return <ErrorRestorePassword setScreen={setScreen}> </ErrorRestorePassword>
        default:
            setScreen(1)
            break;
    }

}

export const SuccesRestorePassword = () => {
    const navigate = useNavigate()
    return (
        <CustomCardRestorePassw>
            <div className='w-full h-4/12  flex justify-center items-center'>
                <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
            </div>
            <div className='w-full h-7/12 px-20'>
                <p className='font-bold text-2xl text-white text-center'>Se ha reestablecido con éxito tu contraseña.</p>
                <p className='pt-6 font-normal text-base text-white text-center'>Puedes volver a ingresar con tu nueva contraseña en la plataforma de Inmersys.</p>
            </div>
            <div className='w-full h-4/12 '>
                <div className='w-full text-center'>
                    <button
                        onClick={() => { navigate("/auth") }}
                        className='w-[236px] h-[48px] rounded bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white text-base'>
                        Ir a inicio
                    </button>
                </div>
            </div>
        </CustomCardRestorePassw>
    )
}

export const ErrorRestorePassword = ({ setScreen }) => {
    const navigate = useNavigate()
    return (
        <CustomCardRestorePassw>
            <div className='w-full h-4/12  flex justify-center items-center'>
                <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
            </div>
            <div className='w-full h-4/12 px-6'>
                <p className='font-bold text-2xl text-white text-center'>No hemos podido reestablecer tu contraseña.</p>
                <p className='pt-6 font-normal text-base text-white text-center'>Ha ocurrido un error, por favor vuelve a intentarlo.</p>
            </div>
            <div className='w-full h-4/12 '>
                <div className='w-full text-center'>
                    <button
                        onClick={() => setScreen(1)}
                        className='w-[236px] h-[48px] rounded bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white text-base'>
                        Intentar de nuevo
                    </button>
                </div>
                <p
                    onClick={() => { navigate("/auth") }}
                    className='text-white text-base font-normal mt-4 text-center cursor-pointer'>Ir a inicio</p>
            </div>
        </CustomCardRestorePassw>
    )
}

export default FormRestorePassword
